import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-test-request',
  templateUrl: './test-request.component.html',
  styleUrls: ['./test-request.component.scss'],
})
export class TestRequestDialogComponent implements OnInit {
  public exigenciasForm: FormGroup;
  checked: boolean = false;

  public text: string;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<TestRequestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.text = data.text;
  }

  ngOnInit(): void {
    this.exigenciasForm = this.formBuilder.group({
      checkExigencias: [false, Validators.requiredTrue],
    });
  }

  onclick() {
    console.log(this.checked);
  }

  accept(): void {
    let exigencias: string;
    if (this.exigenciasForm.controls.checkExigencias.value) {
      exigencias = 'S';
    } else {
      exigencias = 'N';
    }
    this.dialogRef.close({ exigencias: exigencias });
  }

  exit(): void {
    this.dialogRef.close();
  }
}
